import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export interface ActivityEvent {
  project_id: string;
  actor_id: string;
  actor_name: string;
  verb: string;
  entity_type: string;
  entity_id: string | null;
  entity_label: string | null;
  summary: string | null;
  created_at: string;
}

export async function getActivity(
  projectId: string,
  before?: string,
  limit = 50
): Promise<ActivityEvent[]> {
  const { data } = await axios.get(`${BASE}/api/projects/${projectId}/activity`, {
    params: { before, limit },
  });
  return data;
}

export interface MyActivityEvent extends ActivityEvent {
  project_name: string;
}

export async function getMyActivity(before?: string, limit = 50): Promise<MyActivityEvent[]> {
  const { data } = await axios.get(`${BASE}/api/activity/mine`, {
    params: { before, limit },
  });
  return data;
}

export function lastSeenKey(projectId: string, userId: string) {
  return `activity-last-seen:${projectId}:${userId}`;
}

export function getLastSeen(projectId: string, userId: string): string | null {
  return localStorage.getItem(lastSeenKey(projectId, userId));
}

export function markSeen(projectId: string, userId: string) {
  localStorage.setItem(lastSeenKey(projectId, userId), new Date().toISOString());
}
